import React from 'react';

import {
    ADDRESS_LINK,
    CALL_NOW_BTN_SECONDARY,
    CERTIFICATION_BADGE,
    DIRECTORY_SEARCH_RESULT_CARD_LINK,
    PRACTICE_LOCATION_CARD,
    PROFILE_CARD,
    PROFILE_CONTACT_TYPE,
    SEE_OUT_OF_POCKET_COSTS,
} from 'core/constants.js';
import {CardV2} from '@healthshareau/hs-component-library';
import {PracticeStoreContextV2} from 'core/stores/RootStore.js';

class PracticeListCardV2 extends React.Component {
    static contextType = PracticeStoreContextV2;
    constructor(props) {
        super(props);
    }

    getFees() {
        const {loadFees} = this.context;
        if (loadFees) {
            return {
                feesUrl: `#fees`,
                gaObjectType: PROFILE_CARD,
                gaSelector: SEE_OUT_OF_POCKET_COSTS,
            };
        }
        return null;
    }

    render() {
        const {
            address,
            avatar,
            locality: {
                name: localityName,
                postCode,
                state: {name: stateName},
            },
            name,
            offersHicaps,
            offersTelehealth,
            practiceUrl,
            phoneNumbers,
            certifications,
        } = this.props.practice;

        const {
            practice: {isRetired},
            rootStore: {
                paramStore: {hasSkin},
                healthFundStore: {healthFundThemeColor},
            },
            showCallNow,
            loadFees,
            profileCardCTA,
        } = this.context;

        const PPnumber = phoneNumbers[0]?.formattedNumber;

        return (
            <CardV2
                alt={name}
                addressChip={{
                    addressText: address,
                    gaObjectType: PROFILE_CARD,
                    gaSelector: ADDRESS_LINK,
                }}
                customClass="square-shape"
                colorTheme={
                    hasSkin && healthFundThemeColor
                        ? healthFundThemeColor
                        : null
                }
                asElement="li"
                avatar={{
                    src: avatar?.includes('empty_avatar') ? '' : avatar,
                    icon: 'building',
                }}
                button={
                    !isRetired &&
                    profileCardCTA(
                        this.props.practice,
                        PROFILE_CARD,
                        PROFILE_CONTACT_TYPE,
                    )
                }
                dataTestId={PROFILE_CARD}
                gaObjectType={PROFILE_CARD}
                gaSelector={DIRECTORY_SEARCH_RESULT_CARD_LINK}
                header={`${localityName} ${stateName} ${postCode}`}
                href={!this.props.disabled ? practiceUrl : undefined}
                offersHicaps={offersHicaps}
                offersTelehealth={offersTelehealth}
                subheader={name}
                disabled={this.props.disabled || !practiceUrl}
                phoneChip={
                    !isRetired && {
                        phone: PPnumber,
                        gaObjectType: PROFILE_CARD,
                        gaSelector: CALL_NOW_BTN_SECONDARY,
                    }
                }
                onPhoneClick={
                    !isRetired &&
                    (() =>
                        showCallNow({
                            ...this.props.practice,
                            type: PROFILE_CONTACT_TYPE,
                        }))
                }
                feesChip={loadFees && this.getFees()}
                feesColor={healthFundThemeColor}
                certificateChips={certifications}
                certificateTracking={{
                    gaObjectType: PRACTICE_LOCATION_CARD,
                    gaSelector: CERTIFICATION_BADGE,
                    dataTestId: CERTIFICATION_BADGE,
                }}
            />
        );
    }
}

export default PracticeListCardV2;
